export default defineNuxtPlugin((nuxtApp) => {
  // Parse stack trace to get component info
  const parseStackTrace = (stack: string) => {
    if (!stack) return 'Unknown'
    
    const lines = stack.split('\n')
    const componentInfo = lines.find(line => line.includes('/components/'))
    
    if (componentInfo) {
      const match = componentInfo.match(/components\/(.*?)\.vue/)
      return match ? match[1] : 'Unknown'
    }
    
    return 'Unknown'
  }

  // Format error details
  const formatError = (error: any, component?: string, info?: string) => ({
    component,
    message: error?.message,
    info,
    stack: error?.stack,
    errorLocation: error?.stack ? parseStackTrace(error.stack) : 'Unknown',
    url: process.client ? window?.location?.href : undefined
  })

  // Handle Vue errors
  nuxtApp.vueApp.config.errorHandler = (error, instance, info) => {
    console.error('Vue Error:', formatError(
      error,
      instance?.$options?.name || instance?.$options?.__file,
      info
    ))
  }

  // Handle Nuxt errors
  nuxtApp.hook('vue:error', (error, instance, info) => {
    console.error('Nuxt Error:', formatError(
      error,
      instance?.$options?.name || instance?.$options?.__file,
      info
    ))
  })

  // Handle uncaught errors
  if (process.client) {
    window.onerror = (message, source, lineno, colno, error) => {
      console.error('Uncaught Error:', formatError(
        error || { message, stack: '' },
        source
      ))
    }

    window.addEventListener('unhandledrejection', (event) => {
      console.error('Unhandled Promise Rejection:', formatError(
        event.reason
      ))
    })
  }
})
